import PricingTable from "./pricing-table/PricingTable";

export default function SubscriptionSettings() {
    return <PricingTable />;
}
